import { YearMonthDay } from '@square/dashboard-protos/models/squareup/common/time';
const CONNECT_API_PARSE_PATTERN = /^(\d{4})((-)(\d{2}))?((-)(\d{2}))?/;
const US_PARSE_PATTERN = /^(\d{2})((\/)(\d{2}))?((\/)(\d{4}))?/;
export const ConnectApiDate = {
  parse(str) {
    return [...(CONNECT_API_PARSE_PATTERN.exec(str) ?? [])].reduce(reduceMatchForConnect, YearMonthDay.create());
  },
  format(value) {
    const year = value.year === 0 ? '' : `${value.year}-`;
    const month = value.monthOfYear === 0 ? '' : `${withLeadZero(value.monthOfYear)}-`;
    const day = value.dayOfMonth === 0 ? '' : `${withLeadZero(value.dayOfMonth)}`;
    return `${year}${month}${day}`;
  }
};
export const USDate = {
  parse(str) {
    return [...(US_PARSE_PATTERN.exec(str) ?? [])].reduce(reduceMatchForUs, YearMonthDay.create());
  },
  format(value) {
    const year = value.year === 0 ? '' : value.year;
    const month = value.monthOfYear === 0 ? '' : `${value.monthOfYear < 10 ? '0' : ''}${value.monthOfYear}/`;
    const day = value.dayOfMonth === 0 ? '' : `${value.dayOfMonth < 10 ? '0' : ''}${value.dayOfMonth}/`;
    return `${month}${day}${year}`;
  }
};
function withLeadZero(x) {
  if (x < 10) {
    return `0${x}`;
  } else {
    return x.toString();
  }
}

/**
 * Assuming a RegExp pattern CONNECT_API_PARSE_PATTERN, this
 * method reduces the RegExp.prototype.exec method's return value into a
 * YearMonthRecord.
 */
function reduceMatchForConnect(record, next, idx) {
  switch (idx) {
    case 1:
      {
        const year = next == null ? undefined : Number.parseInt(next, 10);
        return YearMonthDay.create({
          ...record,
          year
        });
      }
    case 4:
      {
        const monthOfYear = next == null ? undefined : Number.parseInt(next, 10);
        return YearMonthDay.create({
          ...record,
          monthOfYear
        });
      }
    case 7:
      {
        const dayOfMonth = next == null ? undefined : Number.parseInt(next, 10);
        return YearMonthDay.create({
          ...record,
          dayOfMonth
        });
      }
    default:
      return record;
  }
}

/**
 * Assuming a RegExp pattern `/^(\d{2})((\/)(\d{2}))?((\/)(\d{4}))?/`, this
 * method reduces the RegExp.prototype.exec method's return value into a
 * YearMonthRecord.
 */
function reduceMatchForUs(record, next, idx) {
  switch (idx) {
    case 1:
      {
        const monthOfYear = next == null ? undefined : Number.parseInt(next, 10);
        return YearMonthDay.create({
          ...record,
          monthOfYear
        });
      }
    case 4:
      {
        const dayOfMonth = next == null ? undefined : Number.parseInt(next, 10);
        return YearMonthDay.create({
          ...record,
          dayOfMonth
        });
      }
    case 7:
      {
        const year = next == null ? undefined : Number.parseInt(next, 10);
        return YearMonthDay.create({
          ...record,
          year
        });
      }
    default:
      return record;
  }
}